import { type FocusEventHandler, type FocusEvent, useCallback } from 'react';

const usePopoverBlurCallback = (onBlur: FocusEventHandler<HTMLDivElement>) => {
    return useCallback(
        (e: FocusEvent<HTMLDivElement, Element>) => {
            // relatedTarget is the element that was clicked to trigger the blur
            // event. If one of the layer buttons was clicked, the popover will
            // be closed by its click handler so we don't need to close it here.
            // This resolves a Windows 10 bug (SPL-247466)
            if (e.relatedTarget?.getAttribute('role') === 'menuitem') {
                return;
            }
            onBlur(e);
        },
        [onBlur]
    );
};

export default usePopoverBlurCallback;
